import React, {Component} from 'react';

/**
 * ### About
 *The StoreConnect component in the SIM library uses the higher components concept in React to wrap a component and pass some additional props to it. You can use StoreConnect to wrap your map component and expose the stores of the SIM library.
 *
 *If you would like more information about higher order components in React [click here](https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750)
 * @param {React.Component} ChildComponent The component you would like to wrap
 * @param {Object} stores An object mapping storeName and store
 * @return {React.Component}
 *
 */
export default function (ChildComponent, stores) {

  var getStoreData = function () {
    return Object.keys(stores).reduce(function (state, storeName) {
      state[storeName] = stores[storeName].data;
      return state;
    }, {});
  };

  /**
   * Returns a StoreConnect component that connects to the stores
   */
  return class StoreConnect extends Component {
    constructor () {
      super();

      this.state = getStoreData();
      this.storesUpdate = this.storesUpdate.bind(this);
    }

    componentDidMount () {
      Object.keys(stores).forEach((storeName) => {
        stores[storeName].onUpdate(this.storesUpdate);
      });
    }

    componentWillUnmount () {
      Object.keys(stores).forEach((storeName) => {
        stores[storeName].removeUpdateListener(this.storesUpdate);
      });
    }

    storesUpdate () {
      this.setState(getStoreData());
    }

    render () {
      return <ChildComponent {...this.state} {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./frontend/react/sim/core/flux/StoreConnect.js